import React, { useEffect } from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";

function OrderStatusTypeFilter(props) {
  const { classes } = props;

  let value = "ALL";

  if (props["queued"]?.value === 0) {
    value = "0";
  } else if (props["queued"]?.value === 1) {
    value = "1";
  } else if (Array.isArray(props["queued"]?.value)) {
    value = "2";
  }

  const queued = [
    {
      value: "ALL",
      label: getTranslation("bestellingen.filers.status.all", "Alle orders"),
    },
    {
      value: "0",
      label: getTranslation("bestellingen.filers.queued.normal", "Normale orders"),
    },
    {
      value: "1",
      label: getTranslation("bestellingen.filers.status.queued", "Queued orders"),
    },
    {
      value: "2",
      label: getTranslation("bestellingen.filers.status.failed", "Mislukte orders"),
    },
  ];

  useEffect(() => {
    if (!props.vestiging_id && value === "2") {
      props.setFilter("queued", null);
    }
  }, [props.vestiging_id]);

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let selectedIsQueueOrder = e.target.value;

        switch (selectedIsQueueOrder) {
          case "ALL":
            props.setFilter("queued", null);
            break;
          case "0":
            props.setFilter("queued", { field: "queued", operator: "=", value: 0 });
            break;
          case "1":
            props.setFilter("queued", { field: "queued", operator: "=", value: 1 });
            break;
          case "2":
            props.setFilter("queued", {
              field: "",
              operator: "or",
              value: [
                { field: "queued", operator: "=", value: 2 },
                { field: "vestiging.apiProvider", operator: "!=", value: "JAMEZZ" },
              ],
            });
            break;
        }
      }}
      value={value}
    >
      {queued.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          disabled={!props.vestiging_id ? item.value === "2" : null}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["queued"]: state.filtersV2["queued"],
  ["vestiging_id"]: state.filtersV2["vestiging_id"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OrderStatusTypeFilter, productenStyle));
